import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
import { FormattedMessage, injectIntl } from 'react-intl'
import styles from './show-policy-modal.styl'
import { FormattedHTMLMessage } from 'react-intl'

@injectIntl
class ShowPolicyModal extends Component {
    static propTypes = {
        modalId: PropTypes.string,
        intl: PropTypes.object.isRequired,
        modal: PropTypes.func,
        policyName: PropTypes.string.isRequired,
        policyContent: PropTypes.string.isRequired
    }

    handleCloseModal = () => {
        this.props.modal(null)
    }

    render() {
        const {
            modalId,
            policyName,
            policyContent
        } = this.props

        return (
            <Modal id={modalId} customActions>
                <Title h2>{policyName}</Title>
                <div className={styles.policyContent} >
                    <div>
                        <FormattedHTMLMessage
                            id={`${modalId}-policy-content`}
                            defaultMessage={policyContent}

                        />
                      </div><br />
                    <Button type="button" onClick={this.handleCloseModal} secondary>
                        <FormattedMessage id="button.close" defaultMessage="Close" />
                    </Button>
                </div>
            </Modal>
        )
    }
}

export default ShowPolicyModal
